import {Injectable} from '@angular/core';
import {ContractStepModel} from '../../../models/contract.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DocViewComponent} from '../../../components/doc-view/doc-view.component';
import {SafeResourceUrl} from '@angular/platform-browser';
import {ViewImageFormComponent} from '../components/image-show-form/image-show-form';

@Injectable({
    providedIn: 'root'
})
export class GraphKnDialogService {
    public stepsToAdd: ContractStepModel[] = [];
    docViewComponentDialogRef: MatDialogRef<DocViewComponent, DocViewComponent> | undefined = undefined
    docViewImageDialogRef: MatDialogRef<ViewImageFormComponent, ViewImageFormComponent> | undefined = undefined

    constructor(
        private dialog: MatDialog
    ) {
    }
    openImageViewer(link: SafeResourceUrl, file_name: string) {
        this.docViewImageDialogRef = this.dialog.open(ViewImageFormComponent, {
            maxWidth: '1500px',
            //minWidth: '80%',
            maxHeight: '96vh',
            panelClass: 'add-document-contract-step-padding-modalbox'
        })
        this.docViewImageDialogRef.componentInstance.imageURL = link;
        this.docViewImageDialogRef.componentInstance.file_name = file_name;
    }

    openDocViewComponent(fileUkey: string) {
        let docViewComponentDialogRef = this.dialog.open(DocViewComponent, {
            minWidth: '90vw',
            minHeight: '96vh',
            panelClass: 'add-document-contract-step-padding-modalbox'
        })
        docViewComponentDialogRef.componentInstance.fileUkey = fileUkey
        docViewComponentDialogRef.componentInstance.zoomExt = '100'
    }
}